export const ENV = import.meta.env.VITE_ENV
export const PRODUCT_NAME = import.meta.env.VITE_PRODUCT_NAME
export const API_URL = import.meta.env.VITE_API_URL
export const API_PORTAL_URL = import.meta.env.VITE_API_PORTAL_URL
export const DEFAULT_STRIPE_PK = import.meta.env.VITE_STRIPE_PK
export const DEFAULT_STRIPE_NAME = import.meta.env.VITE_STRIPE_NAME
export const AMPLITUDE_KEY = import.meta.env.VITE_AMPLITUDE_KEY
export const BI_DOMAIN = import.meta.env.VITE_BI_DOMAIN
export const FB_PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID
export const ENABLE_PAYPAL = import.meta.env.VITE_ENABLE_PAYPAL
export const GOOGLE_SIGNUP_CLIENT_ID = import.meta.env.VITE_GOOGLE_SIGNUP_CLIENT_ID
export const GOOGLE_MEASUREMENT_ID = import.meta.env.VITE_GOOGLE_MEASUREMENT_ID
export const GOOGLE_ADS_ID = import.meta.env.VITE_GOOGLE_ADS_ID
export const TIKTOK_PIXEL_ID = import.meta.env.VITE_TIKTOK_PIXEL_ID
export const HOTJAR_ID = import.meta.env.VITE_HOTJAR_ID
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
export const CROWDIN_DIST = import.meta.env.VITE_CROWDIN_DIST_HASH
export const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY
export const GTM_ID = import.meta.env.VITE_GTM_ID

export const IS_DEV = ENV === 'development'
export const IS_PROD = ENV === 'production'
